import { CheckoutAdapter } from '@spartacus/checkout/base/core';
import { Address } from '@spartacus/core';
import { Order } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { CustomPayPalPayment, CustomRedsysPayment } from '../models/custom-checkout.model';

export abstract class CustomCheckoutAdapter extends CheckoutAdapter {
  /**
   * Abstract method used to load Redsys Payment.
   *
   * @param userId The `userId` for given user
   * @param cartId The `cartId` for cart used
   */
  abstract loadRedsysPayment(
    userId: string,
    cartId: string,
    saveCard: boolean,
  ): Observable<CustomRedsysPayment>;

  /**
   * Abstract method used to load Sequra Payment.
   *
   * @param userId The `userId` for given user
   * @param cartId The `cartId` for cart used
   * @param paymentId The `paymentId` used
   */

  abstract loadSequraPayment(
    userId: string,
    cartId: string,
    paymentId: string,
  ): Observable<any>;

  /**
   * Abstract method used to load Sequra Payment.
   *
   * @param userId The `userId` for given user
   * @param cartId The `cartId` for cart used
   * @param paymentId The `paymentId` used
   */

  abstract loadPaypalPayment(
    userId: string,
    cartId: string,
    paymentId: string,
  ): Observable<CustomPayPalPayment>;

  /**
   * Abstract method used to load Sequra Payment.
   *
   * @param userId The `userId` for given user
   * @param cartId The `cartId` for cart used
   */

  abstract createPaypalOrder(
    userId: string,
    cartId: string,
    paymentId: string,
    token: string,
    PayerID: string
  ): Observable<Order>;

  /**
   * Abstract method used to Simulate orders.
   *
   * @param userId The `userId` for given user
   * @param cartId The `cartId` for cart used
   */
  abstract simulateOrder(
    userId: string,
    cartId: string,
  ): Observable<any>;

  /**
   * Abstract method used to Validate cart.
   *
   * @param userId The `userId` for given used
   * @param cartId The `cartId` for cart used
   */
  abstract validateCart(
    userId: string,
    cartId: string,
  ): Observable<any>;

  abstract update(
    userId: string,
    addressId: string,
    address: Address
  ): Observable<{}>;
  /**
   * Abstract method used to check unavailable products in cart.
   *
   * @param userId The `userId` for given used
   * @param cartId The `cartId` for cart used
   */
  abstract unavailableProducts(
    userId: string,
    cartId: string,
  ): Observable<any>;

}
